import type { WorkspaceBrand } from "@/lib/account-workspace";
import { AccountSwitcher } from "./AccountSwitcher";
import { BrandContextSwitcher } from "./BrandContextSwitcher";

export type ContextHeaderLevel = "account" | "brand" | "app";

export type ContextHeaderProps = {
  level: ContextHeaderLevel;
  brand?: WorkspaceBrand | null;
  appTitle?: string | null;
};

/**
 * Single sidebar top region (Logo slot): current product/context, switchable.
 * - account: AccountSwitcher (AccountIcon + name + plan/expiry)
 * - brand: BrandIcon + brand name +「品牌运营」; switch brands / create brand
 * - app: brand + app name subtitle; same brand dropdown
 */
export function ContextHeader({ level, brand = null, appTitle = null }: ContextHeaderProps) {
  if (level === "account") {
    return <AccountSwitcher />;
  }

  return (
    <BrandContextSwitcher
      brand={brand}
      appTitle={level === "app" ? appTitle : null}
    />
  );
}
